import { AfterContentInit, AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../shared/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AuthService } from '../../core/services/auth.service';
import { ToastrService } from 'ngx-toastr';
import { DataService } from 'src/app/core/services/data.service';
import { environment } from 'src/environments/environment';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { DatePipe } from '@angular/common';
import { catchError, EMPTY, reduce, Subject, tap } from 'rxjs';
import { XmppService } from '../../core/services/xmpp.service';
import { MatExpansionPanel } from '@angular/material/expansion';

declare let Strophe: any;
declare let $msg: any;
declare let $pres: any;
declare let $iq: any;
declare let $: any;

interface DocumentCategory {
  id: string;
  title: string;
  count: number;
  icon: string;
  isActive: boolean;
  documentTypes?: string[];
}

@Component({
    selector: 'app-chats',
    templateUrl: './chats.component.html',
    styleUrls: ['./chats.component.css'],
    standalone: false
})

export class ChatsComponent implements OnInit {
  @ViewChildren(MatExpansionPanel) expansionPanels!: QueryList<MatExpansionPanel>;
  @ViewChild('chatBody') chatBodyRef!: ElementRef;
  @ViewChild('messageTextarea') messageTextareaRef!: ElementRef;

  selectedUser: any[] = [];
  entityClients: any[] = [];
  clientSearch: string = '';
  hideRuleContent: boolean[] = [];

  activeTab: string = 'solo';
  selectedChatUser: any = null;
  activeClient: any = null;
  activeFirm: any = null;
  selectedContact: any = null;
  message: string = '';
  messages: any[] = [];
  panelOpenState: boolean = false;

  selectedCategoryTitle: string = 'all';
  showNoHealthConnectionsMsg: boolean = false;

  action: any = null;
  selectedFirmJid: string = '';
  selectedFirm: string = '';
  firmUsersMap: Map<string, any[]> = new Map();

  get firmUsersList(): any[] {
    return this.firmUsersMap.get(this.action) || [];
  }

  private getUserId(user: any): string {
    return String(user?.id ?? user?.lawyer_id ?? user?.rel_id ?? '');
  }

  private normalizeFirmUsers(users: any[] = []): any[] {
    return users.map((user: any) => ({
      ...user,
      id: user?.id ?? user?.lawyer_id ?? user?.rel_id ?? user?.guid ?? '',
    }));
  }

  private queryParamsSub: any = null;
  private appointmentInterval: any = null;
  searchText: string = '';

  documentCategories: DocumentCategory[] = [
    { id: 'all', title: 'All', count: 0, icon: 'group', isActive: true },
    { id: 'solo', title: 'Solo', count: 0, icon: 'person', isActive: false },
    { id: 'firm', title: 'Firm', count: 0, icon: 'business', isActive: false },
  ];

  connectionUser: any[] = [];
  filteredConnectionUser: any[] = [];
  selectedFirmId: string | null = null;
  selectedUserId: any = null;
  expandedFirmIds: Set<string> = new Set<string>();

  domain = environment.xmppDomain;
  toJID = '';
  toName = 'Select Contact';
  ownerName = '';
  contactList = [];
  contactSelected = false;
  USERNAME = '';
  PASSWORD: any;
  // NOTE: ownerJID is a getter so it always reads the current value from localStorage.
  // Capturing it as a class field at init time risks reading a stale/null value on re-login.
  get ownerJID(): string | null { return localStorage.getItem('jid'); }
  URL = 'wss://' + this.domain + ':5443/ws';
  imgurl: any;
  messegeInput: string = '';
  existingData: { bizType: string; guid?: string; name?: string } = { bizType: '' };
  chatUserName: any;
  totalUser: any = 0;
  User = true;
  isConsultationEnded = false;
  // true when the selected lawyer's subscription has expired (API isSubActive === false)
  isLawyerInactive = false;
  isUpcomingAppointment = false;

  // Typing indicator (XEP-0085)
  isContactTyping = false;
  private typingTimeout: any;
  private lastTypingSent = 0;
  private readonly TYPING_THROTTLE = 3000;

  // Last message preview / last-seen — keyed by "<guid>@<domain>"
  conversationMetaMap: Record<string, any> = {};

  // MAM pagination
  isLoadingMore = false;
  private oldestMessageId: string | null = null;
  private hasMoreMessages = true;
  private readonly PAGE_SIZE = 25;
  private mamMessagesBuffer: any[] = [];
  private boundScrollHandler = this.onMessagesScroll.bind(this);

  constructor(
    private auth: AuthService,
    private router: Router,
    private location: Location,
    private toastr: ToastrService,
    private _Activatedroute: ActivatedRoute,
    private xmppService: XmppService
  ) {}

  ngOnDestroy(): void {
    this.queryParamsSub?.unsubscribe();
    if (this.appointmentInterval) {
      clearInterval(this.appointmentInterval);
      this.appointmentInterval = null;
    }
    this.xmppService.unregisterMessageHandler();
    this.xmppService.unregisterConnectCallback();
    this.xmppService.unregisterPresenceHandler();
    clearTimeout(this.typingTimeout);
    if (this.chatBodyRef?.nativeElement) {
      this.chatBodyRef.nativeElement.removeEventListener('scroll', this.boundScrollHandler);
    }
  }

  ngOnInit() {
    this.getRelationships().subscribe({
      next: () => {
        this.ownerName =
          localStorage.getItem('first_name') +
          ' ' +
          localStorage.getItem('last_name');

        this.xmppService.registerMessageHandler(this.stanzaHandler.bind(this));
        this.xmppService.registerConnectCallback(this.onConnect.bind(this));
        this.xmppService.registerPresenceHandler(this.onPresence.bind(this));
        this.xmppService.connect();

        this.scrollToBottom();

        this.queryParamsSub = this._Activatedroute.queryParams.subscribe((params) => {
          const guid = params['guid'];
          const type = params['type'];
          const firmId = params['firm_id'] || params['firmId'];
          const lawyerId = params['lawyer_id'] || params['lawyerId'];
          if (guid || firmId || lawyerId) {
            this.openChatFromAppointment(guid, type, firmId, lawyerId);
          }
        });
      },
      error: (err) => {
        console.error('Failed to get relationships:', err);
      },
    });
  }

  getRelationships() {
    return this.auth.getLawyers().pipe(
      tap((res: any) => {
        this.connectionUser = res.lawyers || [];

        const soloCount = this.connectionUser.filter(
          (u: any) => u.type === 'solo'
        ).length;
        const firmCount = this.connectionUser.filter(
          (u: any) => u.type === 'entity'
        ).length;

        const soloCategory = this.documentCategories.find(
          (cat) => cat.id === 'solo'
        );
        const firmCategory = this.documentCategories.find(
          (cat) => cat.id === 'firm'
        );

        if (soloCategory) soloCategory.count = soloCount;
        if (firmCategory) firmCategory.count = firmCount;

        const allCategory = this.documentCategories.find((cat) => cat.id === 'all');
        if (allCategory) allCategory.count = this.connectionUser.length;

        this.totalUser = this.connectionUser.length;
        this.filterByCategory('all');

        // The XMPP connection and its presenceMap live on the singleton XmppService and
        // persist across navigation (connect/disconnect only happen at login/logout).
        // But connectionUser is refetched fresh on every mount, so without this sync a
        // contact that's already known to be online shows offline until a NEW presence
        // stanza happens to arrive for them.
        this.syncPresenceFromMap();
      })
    );
  }

  private syncPresenceFromMap(): void {
    this.connectionUser.forEach((rel: any) => {
      if (!rel?.guid) return;
      rel.isOnline = (this.xmppService.presenceMap[rel.guid]?.size || 0) > 0;
    });
    if (this.selectedContact?.guid) {
      this.selectedContact.isOnline = (this.xmppService.presenceMap[this.selectedContact.guid]?.size || 0) > 0;
    }
  }

  onCategoryClick(category: DocumentCategory) {
    this.documentCategories.forEach((cat) => (cat.isActive = false));
    category.isActive = true;
    this.selectedCategoryTitle = category.id;
    this.filterByCategory(category.id);

    this.selectedContact = null;
    this.selectedFirmId = null;
    this.selectedUserId = null;
    this.action = null;
    this.messages = [];
    this.User = true;
    this.contactSelected = false;
    this.isContactTyping = false;
  }

  filterByCategory(categoryId: string) {
    if (categoryId === 'solo') {
      this.filteredConnectionUser = this.connectionUser.filter(
        (u: any) => u.type === 'solo'
      );
    } else if (categoryId === 'firm') {
      const firmLawyers = this.connectionUser.filter(
        (u: any) => u.type === 'entity'
      );

      firmLawyers.forEach((lawyer: any) => {
        const existing: any[] = this.firmUsersMap.get(lawyer.firm_id) || [];
        const normalizedLawyer = this.normalizeFirmUsers([lawyer])[0];
        if (!existing.find((u: any) => this.getUserId(u) === this.getUserId(normalizedLawyer))) {
          existing.push(normalizedLawyer);
        }
        this.firmUsersMap.set(lawyer.firm_id, existing);
      });

      // Flat list: every firm member gets its own row ("name - firm_name"),
      // same as the All tab — not one row per firm.
      this.filteredConnectionUser = firmLawyers;
    } else {
      // 'all' — show every connection (solos + one entry per firm lawyer)
      this.filteredConnectionUser = [...this.connectionUser];
    }
  }

  get filteredUsers() {
    const lower = this.searchText.trim().toLowerCase();
    const list = !lower
      ? [...this.filteredConnectionUser]
      : this.filteredConnectionUser.filter((rel) => {
          const name = rel.name || '';
          const firmName = rel.firm_name || '';
          return (
            name.toLowerCase().includes(lower) ||
            firmName.toLowerCase().includes(lower)
          );
        });

    // Most recent conversation first; contacts with no message yet keep their
    // original relative order at the bottom (Array#sort is stable).
    return list.sort(
      (a, b) => this.getLastMessageTimestamp(b) - this.getLastMessageTimestamp(a)
    );
  }

  private getLastMessageTimestamp(rel: any): number {
    return rel?.lastMessageTime ? new Date(rel.lastMessageTime).getTime() : 0;
  }

  // Chat message search. Not using the shared `filter` pipe here — it matches
  // against a `name` field (built for lawyer/document lists) and messages only
  // have `text`, so it was silently returning the list unfiltered.
  get filteredMessages(): any[] {
    const term = this.clientSearch.trim().toLowerCase();
    if (!term) return this.messages;
    return this.messages.filter((m: any) =>
      (m.text || '').toLowerCase().includes(term)
    );
  }

  openChatFromAppointment(guid?: string, type?: string, firmId?: string, lawyerId?: string) {
    if (type === 'solo') {
      const soloCategory = this.documentCategories.find(
        (cat) => cat.id === 'solo'
      );
      if (soloCategory) this.onCategoryClick(soloCategory);
    } else if (type === 'entity') {
      const firmCategory = this.documentCategories.find(
        (cat) => cat.id === 'firm'
      );
      if (firmCategory) this.onCategoryClick(firmCategory);
    }

    // Clear any lingering interval from a previous navigation to this component
    if (this.appointmentInterval) {
      clearInterval(this.appointmentInterval);
      this.appointmentInterval = null;
    }

    this.appointmentInterval = setInterval(() => {
      if (!this.filteredConnectionUser || this.filteredConnectionUser.length === 0) return;

      if (type === 'solo') {
        const soloUser = this.filteredConnectionUser.find(
          (u: any) => {
            if (lawyerId && String(u.id) === String(lawyerId)) return true;
            if (guid && u.guid === guid) return true;
            return guid ? u.firm_guid === guid : false;
          }
        );

        if (soloUser) {
          this.onSelectContact(soloUser);
          this.selectedContact = soloUser;
          clearInterval(this.appointmentInterval);
          setTimeout(() => {
            document
              .querySelector('.contact.active')
              ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }, 300);
          return;
        }
      }

      if (type === 'entity') {
        const firm = this.filteredConnectionUser.find(
          (f: any) => {
            if (firmId && String(f.firm_id) === String(firmId)) return true;
            return guid ? f.firm_guid === guid || f.firm_guid === guid.split('_').slice(0, -1).join('_') : false;
          }
        );

        if (firm) {
          clearInterval(this.appointmentInterval);
          this.selectedFirmId = firm.firm_id;
          this.openFirmPanel(firm.firm_id);
          this.selectedFirm = firm.firm_name;
          this.selectedFirmJid = firm.firm_guid;

          // Primary match: appointments.lawyer_id -> chats.getLawyers().lawyers[].id
          const matchedLawyerFromConnections = this.connectionUser.find(
            (user: any) =>
              String(user?.firm_id) === String(firm.firm_id) &&
              lawyerId &&
              this.getUserId(user) === String(lawyerId)
          );

          if (matchedLawyerFromConnections) {
            const existingFirmUsers = this.firmUsersMap.get(firm.firm_id) || [];
            if (
              !existingFirmUsers.find(
                (user: any) =>
                  this.getUserId(user) === this.getUserId(matchedLawyerFromConnections)
              )
            ) {
              this.firmUsersMap.set(
                firm.firm_id,
                this.normalizeFirmUsers([
                  ...existingFirmUsers,
                  matchedLawyerFromConnections,
                ])
              );
            }
            this.onSelectContactId(matchedLawyerFromConnections, firm.firm_id);
          }

          this.auth.notify_user_list(firm.firm_id).subscribe((resp: any) => {
            if (!resp?.data) return;

            this.selectedFirm = firm.firm_name;
            this.selectedFirmJid = resp['data']['uid'];
            this.firmUsersMap.set(
              firm.firm_id,
              this.normalizeFirmUsers(resp['data']['users'])
            );

            const matchedUser = this.firmUsersMap
              .get(firm.firm_id)
              ?.find((user: any) => {
                if (lawyerId && this.getUserId(user) === String(lawyerId)) return true;
                return guid ? user.guid === guid : false;
              });

            if (matchedUser) {
              this.onSelectContactId(matchedUser, firm.firm_id);
            } else {
              this.selectedContact = firm;
              this.chatUsers(
                firm.firm_guid,
                firm.firm_name,
                true,
                '',
                'Admin',
                'prof'
              );
            }

            setTimeout(() => {
              document
                .querySelector('.firm-panel.actived, .firm-panel.active-with-user')
                ?.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }, 300);
          });
          return;
        }
      }

      if (!type) {
        const directUser = this.filteredConnectionUser.find(
          (u: any) => {
            if (lawyerId && String(u.id) === String(lawyerId)) return true;
            return guid ? u.guid === guid : false;
          }
        );

        if (directUser) {
          this.onSelectContact(directUser);
          clearInterval(this.appointmentInterval);
          return;
        }

        const firm = this.filteredConnectionUser.find(
          (f: any) => {
            if (firmId && String(f.firm_id) === String(firmId)) return true;
            return guid ? f.firm_guid === guid || f.firm_guid === guid.split('_').slice(0, -1).join('_') : false;
          }
        );

        if (firm) {
          this.selectedFirmId = firm.firm_id;
          this.loadFirmUsers(false, firm);
          this.openFirmPanel(firm.firm_id);
          clearInterval(this.appointmentInterval);
        }
      }
    }, 200);
  }

  // ✅ Programmatically open a panel by firm_id using ViewChildren ref
  openFirmPanel(firmId: string) {
    const normalizedFirmId = String(firmId);
    this.action = normalizedFirmId;
    this.selectedFirmId = normalizedFirmId;
    this.expandedFirmIds.add(normalizedFirmId);
  }

  isFirmExpanded(firmId: any): boolean {
    return this.expandedFirmIds.has(String(firmId));
  }

  onPanelOpened(firmId: string) {
    const normalizedFirmId = String(firmId);
    this.action = normalizedFirmId;
    this.selectedFirmId = normalizedFirmId;
    this.expandedFirmIds.add(normalizedFirmId);
  }

  onPanelClosed(firmId: string) {
    const normalizedFirmId = String(firmId);
    this.expandedFirmIds.delete(normalizedFirmId);
    if (String(this.action) === normalizedFirmId) {
      this.action = null;
    }
    if (String(this.selectedFirmId) === normalizedFirmId) {
      this.selectedFirmId = null;
    }
  }

  setTab(tab: string) {
    this.activeTab = tab;
  }

  toggle(index: number, client: any) {
    this.messegeInput = '';
    client.isExpand = !client.isExpand;
    this.hideRuleContent[index] = client.isExpand;
    this.activeFirm = client.id;
  }

  selectChatUser(user: any) {
    this.messegeInput = '';
    this.selectedChatUser = user;
    this.activeClient = user.rel_id || user.id;
    this.selectedUser.forEach((u) => (u.isSelected = false));
    user.isSelected = true;
    this.getNotify(user.id);
  }

  getNotify(id: any) {
    this.auth.notify_user_list(id).subscribe((res: any) => {
      this.firmUsersMap.set(this.action, this.normalizeFirmUsers(res.data.users));
    });
  }

  getAvatar(user: any): string {
    return 'https://i.pravatar.cc/40?u=' + user.id;
  }

  onSelectContact(rel: any) {
    this.selectedContact = rel;
    rel.unreadCount = 0;
    this.clientSearch = '';
    this.messegeInput = '';
    this.User = false;
    this.selectedFirmId = null;
    this.selectedUserId = null;

    this.isConsultationEnded = rel.can_chat === false;
    this.isLawyerInactive = rel.isSubActive === false;

    if (rel.appointment_from) {
      const appointmentTime = new Date(rel.appointment_from).getTime();
      const currentTime = new Date().getTime();
      this.isUpcomingAppointment = appointmentTime > currentTime;
    } else {
      this.isUpcomingAppointment = false;
    }

    this.chatUsers(rel.guid, rel.name, true, '', 'Admin', 'solo');
    // scrollToBottom and focusTextarea are called inside chatUsers → restoreMessages flow.
    // But also call focusTextarea here in case the chat panel was already open (contact re-select).
    this.focusTextarea();
  }

  onSelectFirm(firmId: string) {
    const normalizedFirmId = String(firmId);
    this.selectedFirmId = normalizedFirmId;
    this.action = normalizedFirmId;
    this.selectedUserId = null;
  }

  onSelectContactId(user: any, firmId: string) {
    this.clientSearch = '';
    this.messegeInput = '';
    user.unreadCount = 0;
    this.selectedContact = user;
    this.selectedUserId = user;
    const normalizedFirmId = String(firmId);
    this.selectedFirmId = normalizedFirmId;
    this.action = normalizedFirmId;

    // Match the specific user being selected, not just any lawyer in the firm.
    // Previously this found the first lawyer with matching firm_id, which is wrong when
    // a firm has multiple lawyers — it would read the wrong lawyer's chat allowance.
    const lawyer = this.connectionUser.find(
      (l: any) => l.firm_id === firmId && this.getUserId(l) === this.getUserId(user)
    ) || this.connectionUser.find((l: any) => l.firm_id === firmId);
    this.isConsultationEnded = lawyer ? (lawyer.is_chat_allowed === false || lawyer.can_chat === false) : false;
    this.isLawyerInactive = (lawyer ?? user)?.isSubActive === false;

    if (lawyer?.appointment_from) {
      const appointmentTime = new Date(lawyer.appointment_from).getTime();
      this.isUpcomingAppointment = appointmentTime > new Date().getTime();
    } else {
      this.isUpcomingAppointment = false;
    }

    this.chatUsers(
      this.selectedFirmJid,
      user['name'],
      false,
      user['id'],
      firmId,
      'entity'
    );
    this.focusTextarea();
  }

  // onPanelOpened(firmId: string) {
  //   this.action = firmId;
  // }

  // onPanelClosed(firmId: string) {
  //   if (this.action === firmId) {
  //     this.action = null;
  //   }
  // }

  loadFirmUsers(panelOpenState: boolean, rel?: any): void {
    this.selectedFirm = rel.firm_name;
    this.selectedFirmJid = rel.firm_guid;

    this.auth.notify_user_list(rel.firm_id).subscribe((resp: any) => {
      if (!resp?.data) return;

      this.selectedFirmJid = resp['data']['uid'];
      const apiUsers = this.normalizeFirmUsers(resp['data']['users'] || []);
      const localUsers = this.firmUsersMap.get(rel.firm_id) || [];

      const merged = [...localUsers];
      apiUsers.forEach((apiUser: any) => {
        if (!merged.find((u: any) => this.getUserId(u) === this.getUserId(apiUser))) {
          merged.push(apiUser);
        }
      });

      this.firmUsersMap.set(rel.firm_id, merged);
    });
  }

  onConnect(status: any) {
    if (status === Strophe.Status.CONNECTED) {
      this.fetchRosterOnConnect();
      this.fetchConversationMeta();

      // Do NOT re-register messageHandler here — it is already registered once in ngOnInit.
      // Re-binding on every CONNECTED event replaces the handler with a new function reference,
      // which silently drops messages during reconnect transitions.

      // Only re-open the last active chat session if a contact was actually selected.
      // Without this guard, a reconnect after component re-creation fires chatUsers()
      // with stale existingData, opening a phantom session.
      if (this.contactSelected && this.action != null && this.action !== '') {
        if (this.existingData['bizType'] === 'consumer')
          this.chatUsers(
            this.selectedFirmJid,
            this.selectedFirm,
            true,
            '',
            'Admin',
            this.existingData['bizType']
          );
        else if (this.existingData['guid'])
          this.chatUsers(
            this.existingData['guid'],
            this.existingData['name'] || '',
            true,
            '',
            'Admin',
            this.existingData['bizType']
          );
      }
    }
  }

  // ─────────────────────────────────────────────
  // PRESENCE — online/offline indicator
  // ─────────────────────────────────────────────

  private fetchRosterOnConnect(): void {
    if (this.xmppService.rosterFetched) {
      this.subscribeToUnsubscribedContacts();
      return;
    }
    this.xmppService.rosterFetched = true;

    const rosterIQ = $iq({ type: 'get' }).c('query', { xmlns: 'jabber:iq:roster' });

    this.xmppService.whenConnected(() => {
      this.xmppService.getConnection().sendIQ(rosterIQ, (roster: any) => {
        $(roster).find('item').each((_: any, item: any) => {
          const jid = $(item).attr('jid');
          const sub = $(item).attr('subscription');
          const ask = $(item).attr('ask');
          if (sub === 'both' || sub === 'to' || sub === 'from' || ask === 'subscribe') {
            this.xmppService.subscribedJids.add(jid);
          }
        });
        this.subscribeToUnsubscribedContacts();
      });
    });
  }

  private subscribeToUnsubscribedContacts(): void {
    this.connectionUser.forEach((rel: any) => {
      if (!rel?.guid) return;
      const jid = `${rel.guid}@${this.domain}`;
      if (this.xmppService.subscribedJids.has(jid)) return;
      this.xmppService.subscribedJids.add(jid);
      this.xmppService.whenConnected(() => {
        this.xmppService.getConnection().send($pres({ to: jid, type: 'subscribe' }));
      });
    });
  }

  onPresence(presence: any): void {
    const from = $(presence).attr('from') || '';
    const type = $(presence).attr('type') || 'available';

    // Auto-accept incoming subscription requests, and subscribe back once.
    if (type === 'subscribe') {
      const bareJid = from.split('/')[0];
      this.xmppService.whenConnected(() => {
        this.xmppService.getConnection().send($pres({ to: bareJid, type: 'subscribed' }));
      });
      if (bareJid && !this.xmppService.subscribedJids.has(bareJid)) {
        this.xmppService.subscribedJids.add(bareJid);
        this.xmppService.whenConnected(() => {
          this.xmppService.getConnection().send($pres({ to: bareJid, type: 'subscribe' }));
        });
      }
      return;
    }

    if (!from) return;
    if (['subscribed', 'unsubscribe', 'unsubscribed'].includes(type)) return;

    const bareJid = from.split('/')[0].toLowerCase();
    const guid = bareJid.split('@')[0];
    const myGuid = (this.ownerJID || '').toLowerCase();
    if (guid === myGuid) return;

    const isOnline = (this.xmppService.presenceMap[guid]?.size || 0) > 0;

    const contact = this.connectionUser.find((u: any) => u.guid === guid);
    if (contact) contact.isOnline = isOnline;
    if (this.selectedContact?.guid === guid) this.selectedContact.isOnline = isOnline;
  }

  getPresenceLabel(contact: any): string {
    if (!contact) return '';
    if (contact.isOnline) return 'Online';

    const meta = contact.guid ? this.conversationMetaMap[`${contact.guid}@${this.domain}`] : null;
    if (!meta?.last_seen) return '';
    return `Last seen ${this.formatLastMessageTime(meta.last_seen)}`;
  }

  // ─────────────────────────────────────────────
  // LAST MESSAGE PREVIEW
  // ─────────────────────────────────────────────

  private fetchConversationMeta(): void {
    const jids = this.connectionUser
      .filter((u: any) => !!u.guid)
      .map((u: any) => `${u.guid}@${this.domain}`);
    if (!jids.length || !this.ownerJID) return;

    const userJid = `${this.ownerJID}@${this.domain}`;

    this.auth.getConversationMeta(userJid, jids)
      .pipe(catchError(() => EMPTY))
      .subscribe((response: any) => {
        const metaList = response?.data;
        if (!Array.isArray(metaList)) return;

        metaList.forEach((meta: any) => {
          if (!meta?.chat_jid) return;
          this.conversationMetaMap[meta.chat_jid] = meta;

          const guid = meta.chat_jid.split('@')[0];
          const contact = this.findContact(guid);
          if (!contact) return;

          contact.lastMessage = meta.last_message_preview || contact.lastMessage || '';
          contact.lastMessageTime = meta.last_message_timestamp
            ? new Date(meta.last_message_timestamp)
            : contact.lastMessageTime;
          contact.lastMessageTimeDisplay = meta.last_message_timestamp
            ? this.formatLastMessageTime(meta.last_message_timestamp)
            : contact.lastMessageTimeDisplay || '';

          // Don't clobber an unread count of 0 that was just set by opening this chat —
          // the meta poll can race with selection right after connect/reconnect.
          contact.unreadCount = this.selectedContact?.guid === guid ? 0 : (meta.unread_count || 0);
        });
      });
  }

  private findContact(guid: string): any {
    return this.connectionUser.find((u: any) => u.guid === guid);
  }

  private updateContactPreview(guid: string, text: string, timestamp: Date | string | null): void {
    const contact = this.findContact(guid);
    if (!contact || !timestamp) return;
    contact.lastMessage = text;
    contact.lastMessageTime = timestamp;
    contact.lastMessageTimeDisplay = this.formatLastMessageTime(timestamp);
  }

  formatLastMessageTime(dateInput: Date | string | null): string {
    if (!dateInput) return '';

    const date = new Date(dateInput);
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    const sameDay = (a: Date, b: Date) =>
      a.getDate() === b.getDate() &&
      a.getMonth() === b.getMonth() &&
      a.getFullYear() === b.getFullYear();

    if (sameDay(date, today)) {
      return date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
    }
    if (sameDay(date, yesterday)) return 'Yesterday';
    return date.toLocaleDateString();
  }

  // ─────────────────────────────────────────────
  // TYPING INDICATOR (XEP-0085)
  // ─────────────────────────────────────────────

  onInputChange(): void {
    if (!this.selectedContact || !this.contactSelected) return;

    // Reset debounce on every keystroke — "paused" fires 1s after the LAST keystroke.
    clearTimeout(this.typingTimeout);
    this.typingTimeout = setTimeout(() => {
      this.sendTypingState('paused');
      this.lastTypingSent = 0;
    }, 1000);

    // Throttle "composing" — max once every TYPING_THROTTLE ms.
    const now = Date.now();
    if (now - this.lastTypingSent > this.TYPING_THROTTLE) {
      this.sendTypingState('composing');
      this.lastTypingSent = now;
    }
  }

  private sendTypingState(state: 'composing' | 'paused' | 'gone'): void {
    if (!this.toJID) return;

    const stanza = $msg({
      to: `${this.toJID}@${this.domain}`,
      type: 'chat',
    }).c(state, { xmlns: 'http://jabber.org/protocol/chatstates' });

    this.xmppService.whenConnected(() => {
      this.xmppService.getConnection().send(stanza);
    });
  }

  private handleChatState(msg: any, isComposing: boolean): void {
    let from = $(msg).attr('from') || '';
    if (from.indexOf('/') !== -1) from = from.split('/')[0];
    if (from !== `${this.toJID}@${this.domain}`) return;

    this.isContactTyping = isComposing;
    if (isComposing) this.scrollToBottom();
  }

  // ─────────────────────────────────────────────
  // STANZA DISPATCH — routes MAM history, typing state, and live messages
  // ─────────────────────────────────────────────

  stanzaHandler(msg: any) {
    if ($(msg).attr('type') === 'error') return true;

    // XEP-0313 MAM history result — buffer for the in-flight restoreMessages() page,
    // do not render directly (live messages never carry a <result> element).
    if ($(msg).find('result').length) {
      this.mamMessagesBuffer.push(msg);
      return true;
    }

    // XEP-0085 typing indicators
    const composing = $(msg).find('composing[xmlns="http://jabber.org/protocol/chatstates"]');
    const paused = $(msg).find('paused[xmlns="http://jabber.org/protocol/chatstates"]');
    const gone = $(msg).find('gone[xmlns="http://jabber.org/protocol/chatstates"]');
    if (composing.length || paused.length || gone.length) {
      this.handleChatState(msg, composing.length > 0);
      return true;
    }

    this.xmlParser(msg);
    return true;
  }

  async xmlParser(msg: any) {
    const stanzaId = $(msg).attr('id') || '';
    var timeStamp = new DatePipe('en-US').transform(
      new Date(),
      'MMM dd yyyy HH:mm'
    );

    var from = $(msg).attr('from') || '';
    var to = $(msg).attr('to') || '';
    if (from.indexOf('/') != -1) from = from.split('/')[0];
    if (to.indexOf('/') != -1) to = to.split('/')[0];

    var bodies = $(msg).find('body');
    // Stanzas without a <body> (delivery receipts, chat-state notifications, read markers)
    // must be discarded — Strophe.getText(undefined) throws and would crash the handler.
    if (!bodies || bodies.length === 0) return;
    var body = Strophe.xmlunescape(Strophe.getText(bodies[0]));
    if (!body || body.trim() === '') return;

    // XMPP stanza routing — resolve who this message is with, independent of
    // whichever chat happens to be open right now, so background contacts still
    // get their preview/unread count updated.
    const myFullJid = `${this.ownerJID}@${this.domain}`;
    let action: 'SENT' | 'RECEIVE' | 'NONE' = 'NONE';
    let contactId = '';

    if (to === myFullJid) {
      action = 'RECEIVE';
      contactId = from.split('@')[0];
    } else if (from === myFullJid) {
      action = 'SENT';
      contactId = to.split('@')[0];
    }

    if (action === 'NONE') return;

    const isChatOpen = this.toJID === contactId;

    if (isChatOpen) {
      this.messages.push({ text: body, action: action, timestamp: timeStamp, id: stanzaId });
      this.isContactTyping = false;
      this.scrollToBottom();
    }

    this.updateContactPreview(contactId, body, timeStamp);

    if (action === 'RECEIVE') {
      if (isChatOpen) {
        // XEP-0333 — chat is open, mark this message as displayed immediately.
        this.sendDisplayedMarker(stanzaId, from);
      } else {
        // Chat not open (even though we're connected/online) — bump the unread badge.
        const contact = this.findContact(contactId);
        if (contact) {
          contact.unreadCount = (contact.unreadCount || 0) + 1;
        }
      }
    }
  }

  // ─────────────────────────────────────────────
  // XEP-0333 — READ MARKERS
  // ─────────────────────────────────────────────

  private sendDisplayedMarker(messageId: string, toJid: string): void {
    if (!messageId || !toJid) return;

    const marker = $msg({ to: toJid, type: 'chat' }).c('displayed', {
      xmlns: 'urn:xmpp:chat-markers:0',
      id: messageId,
    });

    this.xmppService.whenConnected(() => {
      this.xmppService.getConnection().send(marker);
    });
  }

  scrollToBottom(): void {
    // setTimeout 0 defers past Angular's change detection so the DOM has already
    // been updated with the latest messages before we read scrollHeight — reading
    // it synchronously right after mutating `messages` was measuring stale height.
    setTimeout(() => {
      try {
        const el = this.chatBodyRef?.nativeElement;
        if (el) el.scrollTop = el.scrollHeight;
      } catch (e) {}
    }, 0);
  }

  focusTextarea(): void {
    try {
      // setTimeout 0 lets Angular finish rendering the chat panel
      // before we attempt to focus — needed when switching contacts
      setTimeout(() => {
        this.messageTextareaRef?.nativeElement?.focus();
      }, 0);
    } catch (e) {}
  }

  ngAfterViewInit() {
    this.scrollToBottom();
  }

  ngAfterViewChecked() {}

  restoreMessages(beforeId?: string, appendOlder: boolean = false) {
    const targetJID = this.toJID;

    // Do not send a MAM query if no contact is selected yet
    if (!targetJID || targetJID.trim() === '') {
      console.warn('[ChatsComponent] restoreMessages() called with empty toJID — skipping.');
      return;
    }
    if (this.isLoadingMore) return;

    if (!appendOlder) {
      this.messages = [];
      this.oldestMessageId = null;
      this.hasMoreMessages = true;
    }

    this.isLoadingMore = true;
    this.mamMessagesBuffer = [];

    // Note: no fixed `id` here (unlike the old fire-and-forget send) — sendIQ needs a
    // unique id per request to demux the response callback, and this can fire more than
    // once per contact (initial page + each "load older" page).
    const query = $iq({ type: 'set' })
      .c('query', { xmlns: 'urn:xmpp:mam:2' })
      .c('x', { xmlns: 'jabber:x:data', type: 'submit' })
      .c('field', { var: 'FORM_TYPE', type: 'hidden' })
      .c('value', {})
      .t('urn:xmpp:mam:2')
      .up()
      .up()
      .c('field', { var: 'with' })
      .c('value', {})
      .t(`${targetJID}@${this.domain}`)
      .up()
      .up()
      .up()
      .c('set', { xmlns: 'http://jabber.org/protocol/rsm' })
      .c('max', {})
      .t(this.PAGE_SIZE.toString())
      .up();

    if (beforeId) {
      query.c('before', {}).t(beforeId).up();
    } else {
      query.c('before');
    }

    const loadedForJID = targetJID;

    this.xmppService.whenConnected(() => {
      this.xmppService.getConnection().sendIQ(
        query,
        (response: any) => this.onMamPageLoaded(loadedForJID, appendOlder),
        (error: any) => {
          console.error('[ChatsComponent] MAM error:', error);
          this.isLoadingMore = false;
          this.mamMessagesBuffer = [];
        }
      );
    });
  }

  private onMamPageLoaded(loadedForJID: string, appendOlder: boolean): void {
    // Contact was switched while this page was in flight — discard the stale result.
    if (this.toJID !== loadedForJID) {
      this.isLoadingMore = false;
      this.mamMessagesBuffer = [];
      return;
    }

    const stanzas = this.mamMessagesBuffer;
    this.mamMessagesBuffer = [];

    if (stanzas.length === 0) {
      this.hasMoreMessages = false;
      this.isLoadingMore = false;
      return;
    }

    const parsed: any[] = [];
    let firstId: string | null = null;

    stanzas.forEach((stanza: any, index: number) => {
      const result = $(stanza).find('result');
      if (index === 0) firstId = result.attr('id');

      const forwarded = result.find('forwarded');
      const message = forwarded.find('message');
      const bodyEl = message.find('body');
      if (!bodyEl.length) return;

      const body = Strophe.xmlunescape(Strophe.getText(bodyEl[0]));
      let from = message.attr('from') || '';
      if (from.indexOf('/') !== -1) from = from.split('/')[0];
      const msgId = message.attr('id') || '';

      const delayStamp = forwarded.find('delay').attr('stamp');
      const timestamp = new DatePipe('en-US').transform(
        delayStamp || new Date(),
        'MMM dd yyyy HH:mm'
      );

      const action = from === `${this.ownerJID}@${this.domain}` ? 'SENT' : 'RECEIVE';
      parsed.push({ text: body, action, timestamp, id: msgId });
    });

    this.oldestMessageId = firstId;
    if (stanzas.length < this.PAGE_SIZE) this.hasMoreMessages = false;

    if (appendOlder) {
      const container = this.chatBodyRef?.nativeElement;
      const oldHeight = container?.scrollHeight ?? 0;
      this.messages = [...parsed, ...this.messages];

      setTimeout(() => {
        if (container) container.scrollTop = container.scrollHeight - oldHeight;
        this.isLoadingMore = false;
      });
    } else {
      this.messages = parsed;
      if (parsed.length) {
        const last = parsed[parsed.length - 1];
        this.updateContactPreview(loadedForJID, last.text, last.timestamp);
        // XEP-0333 — opening the chat: mark the latest message as displayed.
        if (last.id) {
          this.sendDisplayedMarker(last.id, `${loadedForJID}@${this.domain}`);
        }
      }
      this.isLoadingMore = false;
      this.scrollToBottom();
    }
  }

  onMessagesScroll(): void {
    const container = this.chatBodyRef?.nativeElement;
    if (!container) return;
    if (container.scrollTop <= 50 && this.hasMoreMessages && !this.isLoadingMore && this.oldestMessageId) {
      this.restoreMessages(this.oldestMessageId, true);
    }
  }

  selectUser(value: any) {
    // LEGACY STUB — this method is no longer used in the current flow.
    // The active path is: onSelectContact() → chatUsers()
    // The hardcoded JID below is removed to prevent accidental message routing to a stale address.
    console.warn('[ChatsComponent] selectUser() is a legacy stub — do not call directly.');
    this.toName = value;
    this.messages = [];
    this.contactSelected = false; // prevents sends until a real contact is selected
  }

  sendMessage(message: any) {
    if (message.trim() == '') return;
    else if (!this.contactSelected) {
      this.toastr.error('Select contact');
      return;
    }

    var UserName =
      localStorage.getItem('first_name') +
      ' ' +
      localStorage.getItem('last_name');
    var subject =
      UserName + ' ##' + this.ownerJID + '## #N#' + UserName + '#N#';

    var timeStamp = new DatePipe('en-US').transform(
      new Date(),
      'MMM dd yyyy HH:mm'
    );

    this.xmppService.whenConnected(() => {
      const conn = this.xmppService.getConnection();
      const messageId = conn.getUniqueId('msg');
      const msgXML = $msg({
        to: `${this.toJID}@${this.domain}`,
        type: 'chat',
        id: messageId,
      }).c('subject').t(subject);
      msgXML.up().c('body').t(message);

      conn.send(msgXML);
      // Push to UI only after the stanza is dispatched — avoids ghost messages when queued
      this.messages.push({ text: message, action: 'SENT', timestamp: timeStamp, id: messageId });
      this.updateContactPreview(this.toJID, message, timeStamp);
      this.scrollToBottom();
    });

    const from_user_id = localStorage.getItem('PK');

    const guid = localStorage.getItem('jid');

    this.auth
      .create_notification({
        from_user_id,
        to_user_id: this.selectedContact?.id,
        client_type: 'entity',
        message: 'New Message',
        navigation_data: {
          route_name: 'message_client_inbox',
          params: { guid },
        },
      })
      .subscribe();

    this.messegeInput = '';
    this.clientSearch = '';
  }

  getTMFilterValue(value: any) {
    return value.toLowerCase();
  }

  chatUsers(
    jid: string,
    name: string,
    isAdmin: any,
    userid: string,
    firm: string,
    biztype: string
  ) {
    // Notify the previously open chat (if any) that we've left, and clear local typing state.
    if (this.toJID && this.contactSelected) {
      this.sendTypingState('gone');
    }
    clearTimeout(this.typingTimeout);
    this.isContactTyping = false;

    this.toJID = jid;
    if (!isAdmin) this.toJID += '_' + userid;

    if (firm == 'Admin') {
      if (biztype == 'solo') this.toName = name;
      else this.toName = name + ' - ' + firm;
    } else {
      this.toName = firm + ' - ' + name;
    }

    this.messages = [];
    this.contactSelected = true;
    this.restoreMessages();
    this.scrollToBottom();
    this.focusTextarea();

    setTimeout(() => {
      const el = this.chatBodyRef?.nativeElement;
      if (!el) return;
      el.removeEventListener('scroll', this.boundScrollHandler);
      el.addEventListener('scroll', this.boundScrollHandler);
    }, 0);
  }

  getFilterValue(item: any) {
    var name = item.business_name || item.name;
    return name.toLowerCase();
  }

  restricttextSpace(event: any) {
    let inputValue: string = event.target.value;
    inputValue = inputValue.replace(/^\s+/, '');
    inputValue = inputValue.replace(/\s{2,}/g, ' ');
    event.target.value = inputValue;
    return;
  }

  isMessageEmpty(): boolean {
    return !this.messegeInput.trim();
  }

  getSelectedChatDisplayName(): string {
    if (!this.selectedContact) return '';

    // Firm lawyer selected via the firm panel — show lawyer name
    if (this.selectedUserId) {
      return this.selectedContact?.name || this.selectedContact?.firm_name || '';
    }

    // Solo lawyers: always show `name` (the lawyer's personal name from the API).
    // `firm_name` is NOT used here — for solos it may equal `name` or be a practice label,
    // but the intended display value per the API response is the `name` field.
    if (this.selectedContact?.type === 'solo') {
      return this.selectedContact?.name || '';
    }

    // Entity (firm) contacts shown outside the firm panel — show firm_name
    return this.selectedContact?.firm_name || this.selectedContact?.name || '';
  }

  onKeyDown(event: KeyboardEvent) {
    if (
      event.key === ' ' &&
      (!this.messegeInput || this.messegeInput.length === 0)
    ) {
      event.preventDefault();
      return;
    }
    if (event.key === 'Enter' && event.shiftKey) {
      return;
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      this.sendMessage(this.messegeInput);
    }
  }

  // Mobile (WhatsApp-style) — close the open chat and return to the connection list.
  backToList() {
    if (this.toJID && this.contactSelected) {
      this.sendTypingState('gone');
    }
    clearTimeout(this.typingTimeout);
    this.isContactTyping = false;
    this.selectedContact = null;
    this.selectedUserId = null;
    this.selectedFirmId = null;
    this.contactSelected = false;
    this.toJID = '';
    this.messages = [];
    this.User = true;
    this.clientSearch = '';
    this.messegeInput = '';
  }

  gooApp() {
    if (window.history.length > 1) {
      this.location.back();
      return;
    }
    this.router.navigate(['/connections'], {
      queryParams: { category: 'legal' },
    });
  }

  preventLeadingSpace(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const isFirstChar = input.selectionStart === 0;
    if (event.key === ' ' && isFirstChar) {
      event.preventDefault();
    }
  }

  reopenChat() {
    if (!this.selectedContact) return;
    const lawyerId = this.selectedContact.id || this.selectedContact.guid;
    this.router.navigate(['/bookslot'], { state: { lawyerId } });
  }

  navigateToappointments() {
    this.router.navigate(['/appointments']);
  }
}